import { useEffect, useRef, useState } from "react";
import { impression } from "../components/const";

const DetailConteneur = ({ conteneur }) => {
    const [totalqte, setTotalQte] = useState(0);
    const [totalmontant, setTotalMontant] = useState(0);
    const detailproduct = conteneur?.produits
    const printElement = useRef()
    const printElement2 = useRef()

    useEffect(() => {
        if (detailproduct?.length) {
            setTotalQte(detailproduct?.reduce((previous, current) => { return previous + current.quantite }, 0));

            setTotalMontant(detailproduct?.reduce((previous, current) => { return previous + current.montant }, 0));
        }
    }, [detailproduct])

    return (
        <div className="AddModal">
            <div className="modal fade" id="detailConteneur" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Detail du conteneur</h1>
                            <button type="button" className="btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="accordion" id="accordionPanelsStayOpenExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#detail-info" aria-expanded="true" aria-controls="detail-info">
                                            Detail informations achat
                                        </button>
                                    </h2>
                                    <div id="detail-info" className="accordion-collapse collapse ">
                                        <div className="accordion-body" >
                                            <button className="btn btn-primary  w-auto ms-auto m-1" onClick={() => impression(printElement.current, "portrait", "INFORMATIONS D'ACHAT DU CONTENEUR " + conteneur?.conteneur)}>
                                                <bx className="bx bx-printer"></bx>
                                            </button>
                                            <div className="row p-2 table-responsive" ref={printElement}>
                                                <table className="table table-striped table-bordered" >
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th>N°</th>
                                                            <th>LIBELE</th>
                                                            <th>VALEUR</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>01</td>
                                                            <td>DEVISE</td>
                                                            <td>{conteneur?.devise}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>02</td>
                                                            <td>PRIX DU CONTENEUR EN DEVISE</td>
                                                            <td>{conteneur?.Prix?.toLocaleString()}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>03</td>
                                                            <td>VALEUR DU JOUR</td>
                                                            <td>{conteneur?.valeur_du_jour?.toLocaleString()}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>04</td>
                                                            <td>PRIX DU CONTENEUR EN GNF</td>
                                                            <td>{(conteneur?.valeur_du_jour * conteneur?.Prix)?.toLocaleString()}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>05</td>
                                                            <td>DEPENSE TOTAL EN GNF</td>
                                                            <td>{(conteneur?.depense)?.toLocaleString()}</td>
                                                        </tr>
                                                        <tr className="fw-bold">
                                                            <td>06</td>
                                                            <td>MONTANT TOTAL DE REVIENT EN GNF</td>
                                                            <td>{(conteneur?.Montant)?.toLocaleString()}</td>
                                                        </tr>
                                                        <tr className="fw-bold bg-success-subtle">
                                                            <td>07</td>
                                                            <td>TRANSITAIRE</td>
                                                            <td>{(conteneur?.transitaire)?.toUpperCase()}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                                            Liste des produits
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse ">
                                        <button className="btn btn-primary  w-auto ms-auto m-1" onClick={() => impression(printElement2.current, "portrait", "LISTE DES PRODUITS DU CONTENEUR " + conteneur?.conteneur)}>
                                            <bx className="bx bx-printer"></bx>
                                        </button>
                                        <div className="accordion-body">
                                            <div className="row p-2 table-responsive" ref={printElement2}>
                                                {
                                                    <table className="table table-stripped table-bordered">
                                                        <thead className="table-dark border-secondary text-center">
                                                            <tr>
                                                                <th className="text-center">N°</th>
                                                                <th>Produit</th>
                                                                <th>Prix Unitaire</th>
                                                                <th>quantite</th>
                                                                <th>Montant</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                detailproduct?.map((prod, index) => (
                                                                    <tr key={index + 1}>
                                                                        <td>
                                                                            {index + 1}
                                                                        </td>
                                                                        <td>{prod.produit}</td>
                                                                        <td>{`${prod.prix.toLocaleString()} GNF`}</td>
                                                                        <td>{prod.quantite}</td>
                                                                        <td>{`${prod.montant.toLocaleString()} GNF`}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                            <tr className="bg-secondary-subtle">
                                                                <td colSpan={3} className="text-center fs-3 fw-bold">Totaux</td>
                                                                <td className="fw-bold">{totalqte}</td>
                                                                {/* <td className="fw-bold">{totaprix.toLocaleString()} GNF</td> */}
                                                                <td className="fw-bold">{totalmontant.toLocaleString()} GNF</td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default DetailConteneur;